// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17aLd","top":"styles_top__gdDGC","left":"styles_left__1swiU","description":"styles_description__3MMJS"};